<button class="clases__button" type="button" (click)="onClick()">
    <span class="clases__button-icon"><app-icon icon="menu-16x12"></app-icon></span>
    <span class="clases__button-title">{{ label }}</span>
    <span class="clases__button-arrow"><app-icon icon="arrow-rounded-down-9x6"></app-icon></span>
</button>
<div class="clases__menu">
    <div class="clases__arrow"></div>
    <div class="clases__body" (mouseleave)="onMouseleave()">
        <ul class="clases__list">
            <li class="clases__list-padding" role="presentation" (mouseenter)="onMouseleave()"></li>
            <!-- <li
                *ngFor="let item of items"
                [class.clases__item--has-submenu]="item.submenu"
                [class.clases__item--submenu--megamenu]="item.submenu?.type == 'megamenu'"
                [class.clases__item--hover]="item === currentItem"
                (mouseenter)="onMouseenter(item)"
            > -->
            <li *ngFor="let item of items"
                [class.clases__item--has-submenu]="item.submenu"
                [class.clases__item--submenu--megamenu]="item.submenu?.type == 'megamenu'"
                [class.clases__item--hover]="item === currentItem"
                (mouseenter)="onMouseenter(item)"
                
            >
                <ng-template #linkContent>
                    {{ item.des_clas }}
                    <span *ngIf="item.submenu" class="clases__item-arrow">
                        <app-icon icon="arrow-rounded-right-7x11"></app-icon>
                    </span>
                </ng-template>
                <!-- var link = `/shop/clase/${text}` + '/productos'; -->
                <!-- <a *ngIf="!item.external" [routerLink]="item.url" class="clases__item-link" (click)="cargar_catalogo_clases(item.des_clas)"> -->
                <a *ngIf="!item.external"  class="clases__item-link" (click)="cargar_catalogo_clases(item.des_clas)">
                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                </a>
                <a *ngIf="item.external"  class="clases__item-link" >
                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                </a>
            </li>
            <li class="clases__list-padding" role="presentation" (mouseenter)="onMouseleave()"></li>
        </ul>
        <div class="clases__menu-container">
            <ng-container *ngFor="let item of items">
                <ng-container *ngIf="item.submenu">
                    <app-megamenu
                        class="clases__megamenu clases__megamenu--size--{{ item.submenu.size }}"
                        [class.clases__megamenu--open]="item === currentItem"
                        [menu]="item.submenu"
                        (itemClick)="onItemClick()"
                    ></app-megamenu>
                </ng-container>
            </ng-container>
        </div>
    </div>
</div>
